import React from "react"
import Cookies from 'js-cookie'
import GoogleAutoComplete from "../components/google-auto-complete"
import PhoneInput from "../components/phone-input"
import $ from 'jquery/dist/jquery'

export default class QuoteStepsModal extends React.Component
{
    constructor(props)    
    {
        super(props)

        this.state = 
        {
            percentage: '0%',
            error: '',
            redirect: '',
            proid: 0,
            steps:['message'],
            onlyzip: false,
            code: this.props.code,
            zipcode: (Cookies.get('zipcode') !== undefined ? Cookies.get('zipcode') : '')
        }
        
        this.modal_project_types = this.props.modal_project_types
        this.service = this.props.env.service !== undefined ? this.props.env.service : 'https://bookable-api-dev.azurewebsites.net'
        this.site = this.props.env.site !== undefined ? this.props.env.site : 'dumpster'
        this.code = this.props.code
        this.service_type = typeof this.keyword_group === 'object' ? this.keyword_group.service.code : this.keyword_group        
  
        this.state.steps.push('zipcode','project','describe','quotes','mobile','street')
        this.state.steps.push('info') //always last (got submit btn)
        this.state.steps.push('confirm') //keep after info
        this.state.steps.push('ok') //keep after info

        this.forceclose = false
    }
    
    // -------- -STEPS-

    confirmStep = () =>
    {
        return(
            <div key={1} className="step confirm">
                <div className="step-confirm">
                    <div className="modal-body">
                        <h3>Don't stop now. <br/>You're <span>{this.state.percentage}</span> done with your request.</h3>
                    </div>
                    <div className="modal-footer">                                   
                    <a className="btn btn-secondary next" href="#navigation" onClick={ this.closemodal }>CANCEL REQUEST</a> 
                        <a className="btn btn-primary next" href="#navigation" onClick={ this.continue }>CONTINUE REQUEST</a>                          
                    </div>
                </div>
            </div>
        )         
    }
    
    messageStep = (name) =>
    {        
        return(
            <div key={2} className="messagestep step">
                <div className="step-message">
                    <div className="modal-body">
                        <h3>Please help the pro understand your project by answering a few questions.</h3>                        
                    </div>
                    <div className="modal-footer">                                   
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>  
                    </div>
                </div>
            </div>
        )
    }

    okStep = (name) =>
    {        
        return(
            <div key={20} className="okstep step">
                <div className="step-ok">
                    <div className="modal-body">
                        <h3>Thank you! <br/> We received your request.</h3>                        
                    </div>
                </div>
            </div>
        )
    }

    onZipChange = (event) =>
    {        
        this.setState({
            'zipcode': event.target.value
        })
    }

    zipStep = (name) =>
    {      
        //const currentzip = Cookies.get('zipcode') !== undefined ? Cookies.get('zipcode') : this.state.zipcode
        
        return(
            <div key={3} className="zipcodestep step">
                <div className="step-zip">
                    <div className="modal-body">
                        <h3>Where do you need service?</h3>                         
                        <input id="step-zipcode" name="step-zipcode" onChange={this.onZipChange} type="text" value={this.state.zipcode} placeholder="Zip code" maxLength="5"/>  
                        <div className="onError">{this.state.error}</div>                                                   
                    </div>
                    <div className="modal-footer">     
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>                                   
                        <a className="btn btn-primary nextzip next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>  
                    </div>
                </div>
            </div>
        )
    }

    typeStep = (name) =>
    {
        const title = this.site === 'dumpster' ? 'Please select a project type:' : 'What do you need removed?'
        
        //aria-expanded="true"

        return(

            <div key={4} className="projectstep step">
                <div className="step-types">    
                    <div className="modal-body">
                        <div className="types" id="project_types">
                            <div className="items">
                                <h3>{title}</h3>
                                {
                                    this.modal_project_types.map((parent, index) =>
                                    {
                                        if(parent.name === undefined)
                                        {
                                            return ('')
                                        }                                
                                        
                                        const id = parent.name.replace(/ /g,'-').replace(/&/g,'and').replace(/,/g,'-').toLowerCase()
                                        const ulclasses = 'collapse'
                                        const classes = 'collapsed'
                                        
                                        return(

                                            <div key={index} className="project">
                                                <h4 id={'heading__'+id} className={classes} data-toggle="collapse" data-target={'#'+id} aria-controls={id}>
                                                    <span>{parent.name}</span>
                                                    <i className="fas fa-chevron-down"></i>
                                                </h4>
                                                <div className="ulbox">
                                                    <ul id={id} className={ulclasses} aria-labelledby={'heading__'+id} data-parent="#project_types">
                                                    {
                                                        parent.projects.map((project, index2) =>
                                                        {                                   
                                                            return(
                                                                <li key={index2}>
                                                                    <label>
                                                                        <input id={project.id} name="type" value={project.id} type="radio" onChange={this.resetError}/>{' '+project.label}
                                                                    </label> 
                                                                </li>
                                                            )
                                                        })
                                                    }                  
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="onError">{this.state.error}</div>
                        </div>
                    </div>
                    <div className="modal-footer">                                        
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>  
                    </div>
                </div>
            </div>
        )
    }

    detailStep = (name) =>
    {        
        return(
            <div key={5} className="describestep step">
                <div className="step-details">
                    <div className="modal-body">
                        <div className="details">
                            <h4>Please describe your project.</h4>
                            <p>More details help pros provide the right recommendations and price.</p>
                            <textarea name="details" id="details" cols="30" rows="5" onChange={this.resetError}></textarea>
                        </div>
                        <div className="onError">{this.state.error}</div>
                    </div>
                    <div className="modal-footer">
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>   
                    </div>
                </div>
            </div>
        )
    }

    quotesStep = (name) =>
    {
        return(
            <div key={6} className="quotesstep step">
                <div className="step-quotes">
                    <div className="modal-body">
                        <div className="quotes">
                            <h4>How many quotes would you like? </h4>
                            <p>You're more likely to find an available pro if we reach out to <br/> more than one.</p>
                            <ul>
                                <li><label><input id="quote1" name="quotes" value="1" type="radio" onChange={this.resetError}/> Up to 1</label></li>
                                <li><label><input id="quote2"  name="quotes" value="2" type="radio" onChange={this.resetError}/> Up to 2</label></li>
                                <li><label><input id="quote3" name="quotes" value="3" type="radio" onChange={this.resetError}/> Up to 3</label></li>
                            </ul>
                        </div>
                        <div className="onError">{this.state.error}</div>
                    </div>
                    <div className="modal-footer">                                        
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>
                    </div>
                </div>
            </div>
        )
    }

    mobileStep = (name) =>
    {        
        return (
            <div key={7} className="mobilestep step">
                <div className="step-info">
                    <div className="modal-body">
                        <div className="info">
                            <h4>Please add your mobile phone.</h4>
                            <p>You'll be notified by SMS text message if a pro agrees to quote your project.</p>
                            <PhoneInput />
                        </div>
                        <div className="onError">{this.state.error}</div>
                    </div>
                    <div className="modal-footer">                                        
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a>
                    </div>
                </div>
            </div>
        )
    }

    addressStep = (name) =>
    {
        return(
            <div key={8} className="streetstep step">
                <div className="step-address" key="qsm-7">
                    <div className="modal-body" key="qsm-8">
                        <div className="address" key="qsm-9">
                            <h4 className="text-center">Please enter the project address.</h4>  
                            <GoogleAutoComplete
                                apiKey="AIzaSyBT4CSSRrQFlPxv0Pevnu9B1T2HK75_H6g"
                                id = 'street'                                   
                                placeholder = 'Street'
                                resetError = {this.resetError}  
                                key="qsm-10"                          
                                />                                                                                  
                        </div>                        
                        <div className="onError">{this.state.error}</div>
                    </div>
                    <div className="modal-footer">
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <a className="btn btn-primary next"href="#navigation" onClick={(e) => this.next(name, e)}>{'NEXT >'}</a> 
                    </div>
                </div>
            </div>  
        )
    }

    infoStep = (name) =>
    {        
        return(
            <div key={9} className="infostep step">
                <div className="step-info">
                    <div className="modal-body">
                        <div className="info">
                            <h4>Please add your name and email.</h4>
                            <input className="half" id="first-name" type="text" name="firstname" placeholder="First Name" required/>
                            <input className="half" id="last-name" type="text" name="lastname" placeholder="Last Name" required/>
                            <input className="half" id="email" type="email" name="email" placeholder="Email"/>
                        </div>
                        <div className="agree">
                            By clicking Submit, you agree to the <a href="/terms-and-conditions.html">Terms of Use</a> and <a href="/hometown-privacy-policy">Privacy Policy</a>.
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a className="btn btn-secondary back"href="#navigation" onClick={(e) => this.back(name, e)} >{'< BACK'}</a>
                        <button type="submit" className="btn btn-primary btn-preloader">Submit</button>
                    </div>
                </div>
            </div>
        )
    }

    onlyZipStep = () =>
    {
        return(

            <div key={10} className="steps onlyzip">
                <div className="step step-zip the-step-zip">
                    <div className="step-only-zip">
                        <div className="modal-body">
                            <h3>Where do you need service?</h3>
                            <input name="step-zipcode" type="text" onChange={this.onZipChange} placeholder="Zip code" value={this.state.zipcode} maxLength="5"/>                                                     
                            <div className="onError">{this.state.error}</div>
                        </div>
                        <div className="modal-footer">     
                            <button type="submit" className="btn btn-primary btn-preloader">Search</button>
                        </div>
                    </div>
                </div>  
                {this.confirmStep()}
            </div>
        )
    }

    addStep = (step) =>
    {        
        let step_html        
        
        switch (step) 
        {
            case 'message':
                step_html = this.messageStep(step)
                break

            case 'zipcode':
                step_html = this.zipStep(step)
                break

            case 'project':
                step_html = this.typeStep(step)
                break

            case 'describe':
                step_html = this.detailStep(step)
                break

            case 'quotes':
                step_html = this.quotesStep(step)
                break

            case 'mobile':
                step_html = this.mobileStep(step)
                break

            case 'street':
                step_html = this.addressStep(step)
                break

            case 'info':
                step_html = this.infoStep(step)
                break

            case 'onlyzip':
                step_html = this.onlyZipStep()
                break
            
            case 'confirm':
                step_html = this.confirmStep()                            
                break

            case 'ok':
                step_html = this.okStep()                            
                break

            default:
                break
        }    

        return step_html
    }

    allSteps = () =>
    {              
        return(

            <div className="steps all" key="qsm-6">
            {
                this.state.steps.map((step) =>
                {                                              
                    return this.addStep(step)                    
                })
            }                      
            </div>
        )
    }

    // -------- -NAVIGATION-

    back = (name, e) =>
    {
        e.preventDefault()

        this.resetError()        

        const allsteps = this.state.steps
        const index = this.state.steps.findIndex(step => step === name)

        let step_current_name = name+'step'
        let step_back_name = allsteps[ index - 1 ] +'step'    
        let progress = index - 1      

        const field_zipcode = document.getElementsByName('step-zipcode')

        if(field_zipcode.length === 0)
        {
            if(allsteps[ index - 1 ] === 'zipcode')
            {           
                step_current_name = allsteps[ index ] +'step'
                step_back_name = allsteps[ index - 2 ] +'step'
                progress = index - 2 
            }
        }        
        
        const current = document.getElementsByClassName(step_current_name)
        current[0].style.display = 'none'

        const next = document.getElementsByClassName(step_back_name)
        next[0].style.display = 'block'    

        this.progressBar(progress)
    }

    goto = (name) =>
    {
        this.resetError()
        
        const allsteps = this.state.steps
        const index = allsteps.findIndex(step => step === name)
                
        let step_current_name = name+'step'

        if(name === 'ok') step_current_name = 'infostep'

        let step_next_name = allsteps[ index + 1 ] +'step'

        if(name === 'ok') step_next_name = 'okstep'

        let progress = index + 1
 
        const current = document.getElementsByClassName(step_current_name)
        current[0].style.display = 'none'

        const next = document.getElementsByClassName(step_next_name)
        next[0].style.display = 'block'        

        this.progressBar(progress)
    }

    next = (name, e) =>
    {
        if(e !== null) e.preventDefault()  
        this.resetError()        

        const allsteps = this.state.steps
        const index = allsteps.findIndex(step => step === name)       
                
        let step_current_name = name+'step'
        let step_next_name = allsteps[ index + 1 ] +'step'      
        let progress = index + 1   

        const field_zipcode = document.getElementsByName('step-zipcode')

        if(field_zipcode.length === 0)
        {
            if(allsteps[ index + 1 ] === 'zipcode')
            {           
                step_current_name = allsteps[ index ] +'step'
                step_next_name = allsteps[ index + 2 ] +'step'
                progress = index + 2  
            }
        }
        
        if(!this.validateStep(name)) return        

        const current = document.getElementsByClassName(step_current_name)
        current[0].style.display = 'none'

        const next = document.getElementsByClassName(step_next_name)
        next[0].style.display = 'block'        

        this.progressBar(progress)
    }

    // -------- -ELEMENTS-

    progressBar = (index) =>
    {
        const stepsprogress = document.getElementsByClassName('steps-progress')
        const progress = document.getElementsByClassName('progress')
        //const percent = document.getElementsByClassName('progress-message-percent')

        stepsprogress[0].className = index === 0 ? 'steps-progress' : 'steps-progress show'      
        
        index = index === 0 ? 1 : index

        let totalsteps = this.state.steps.length - 2

        if (totalsteps <= 1) {
            totalsteps = this.state.steps.length;
        }

        let currentPercentaje = Math.round((index * (100/totalsteps)));
        if (currentPercentaje > 99) {
            currentPercentaje = 100;
        }

        const percentxt = currentPercentaje + '%'

        progress[0].style.width = percentxt

        this.setState({ percentage: percentxt})
    }

    // -------- -ERRORS-

    onError = (message) =>
    {
        this.setState({ error: message})   
    }

    resetError = () =>
    {
        this.setState({ error: ''})
    }

    sleeper = (ms) =>
    {
        return (x) =>
        {
            return new Promise(resolve => setTimeout(() => resolve(x), ms))
        }
    }
    
    // -------- -VALIDATE-
    validateStep = (stepname) =>
    {              
        switch(stepname)
        {
            case 'zipcode':

                const zip = this.state.zipcode
                const regex = new RegExp('^\\d{5}$')                

                if(!regex.test(zip))
                {
                    this.onError('The zip code must have 5 number.')
                    return false
                }

                this.getKppUrl(zip, false, 'zipcode')
                break

                /*
                if zip response is needed

                this.preloadernext('show')                   
                this.getKppUrl(zip, false, 'zipcode') 
                return false*/                
            
            case 'project':               
                
                const radios = document.getElementsByName('type')

                for (let i = 0; i < radios.length; i++) 
                {
                    if (radios[i].checked) return true                    
                }

                this.onError('Please select one option.')

                return false

            case 'street':

                const citystate = document.getElementsByName('citystate')
 
                if(citystate[0].value !== '') return true                

                this.onError('Please enter the street address.')

                return false  

            case 'describe':

                const details = document.getElementsByName('details')

                if(details[0].value !== '') return true   
                
                this.onError('Please enter more details.')

                return false 
                
            case 'mobile':

                const mobile = document.getElementsByName('phone')

                if(mobile[0].value !== '') return true   
                
                this.onError('Please enter your Mobile Phone number.')

                return false

            case 'quotes':

                const quotes = document.getElementsByName('quotes')

                for (let i = 0; i < quotes.length; i++) 
                {
                    if (quotes[i].checked) return true                    
                }

                this.onError('Please select one option.')

                return false
            
            default: break
        }        
        
        return true
    }

    // -------- -FUNCTIONS-

    resetModal = () =>
    {
        this.forceclose = false
        
        const steps = document.getElementsByClassName('step')
        const first = document.getElementsByClassName('messagestep')
        const onlyzip = document.getElementsByClassName('the-step-zip')
        const form = document.getElementById('modalForm')

        $('#quote-steps-modal').modal('hide')
        $('.closermodal').removeClass('hide')

        const that = this

        setTimeout(function()
        { 
            that.setState({ percentage: '0%'})            
            
            for(let i = 0; i < steps.length; i++) 
            {
                if(!$(steps[i]).hasClass('confirm')) steps[i].style.display = 'none'              
                if($(steps[i]).hasClass('confirm')) $(steps[i]).removeClass('show')                
            }   
            
            if($('#temp .steps.all').length > 0){ $('#modalForm').append($('#temp .steps.all')) }  
            if($('#temp .steps.onlyzip').length > 0){ $('#modalForm').append($('#temp .steps.onlyzip')) }

            form.reset()

            const stepsprogress = document.getElementsByClassName('steps-progress')
            stepsprogress[0].className = 'steps-progress'       

            first[0].style.display = 'block'  
            onlyzip[0].style.display = 'block'
           
            $('.step').removeClass('small')              
        }, 500)        
    }

    continue = (e) =>
    {
        e.preventDefault(e)
        $('.closermodal').removeClass('hide')
        $('.step.confirm').removeClass('show')
        $('.step').removeClass('small')
    }

    closemodal= (e) =>
    {
        e.preventDefault(e)        
        this.resetModal()  
    }

    confirmClose = (e) =>
    {
        if(this.forceclose)
        {
            this.resetModal()
            return 
        }       
        
        $('.closermodal').addClass('hide')
        
        e.preventDefault(e)     
        $('.step').addClass('small')    
        $('.step.confirm').addClass('show')
    }

    formDataToObject= (formData) =>
    {
        let object = {}
        formData.forEach((value, key) => 
        {            
            switch(key)
            {
                case 'step-zipcode':
                    key = 'zip_code'
                    break

                default:
                    break
            }            
            
            if (!Reflect.has(object, key)) 
            {
                object[key] = value
                return
            }

            if (!Array.isArray(object[key])) 
            {
                object[key] = [object[key]]
            }
            
            object[key].push(value)
        })

        return object
    }

    formData = () =>
    {
        let form = document.getElementById('modalForm')
        const formdata = new FormData(form)
        const data = this.formDataToObject(formdata)

        return data
    }

    handleSubmit = event =>  
    {
        event.preventDefault()

        const form_data = this.formData()

        if(this.state.onlyzip)
        {
            if(!this.validateStep('zipcode')) return
                
            this.preloader('show')
            this.getKppUrl(form_data.zip_code, true)

            return
        }     
        
        this.quoteRequest(form_data)        
    }

    preloader = (action) =>
    {
        const button = document.getElementsByClassName('btn-preloader')
        
        if(action === 'show' )
        {
            button[0].disabled = true
            button[0].className = button[0].className+' show-preloader'  

            return
        }

        button[0].disabled = false
        button[0].className = button[0].className.replace(' show-preloader', '')
    }

    preloadernext = (action) =>
    {
        const button = document.getElementsByClassName('nextzip')
        
        if(action === 'show' )
        {
            button[0].disabled = true
            button[0].className = button[0].className+' show-preloader'  
            return
        }

        button[0].disabled = false
        button[0].className = button[0].className.replace(' show-preloader', '')
        button[0].innerText = 'Next >'
    }

    quoteRequest = (form_data) =>
    {
        this.preloader('show')
        
        const url = this.service+'/api/v1/quote-requests' 

        const street = form_data.street1 !== '' ? form_data.street1 : form_data.street
        const mobile = form_data.phone.replace(/ /g,'').replace(/-/g,'').replace('(','').replace(')','')
        const referral = this.site === 'dumpster' ? 'Hometown Dumpster Rental' : 'Hometown Demolition'

        const json = {
            "project_type": (form_data.type*1),
            "street_address": street,
            "street_address_2": form_data.street2,
            "city": form_data.locality,
            "state": form_data.citystate,
            "zip_code": form_data.zipcode,
            "country": form_data.country,
            "project_description": form_data.details,
            "quotes": form_data.quotes,
            "first_name": form_data.firstname,
            "last_name": form_data.lastname,
            "email": form_data.email,
            "mobile_phone": mobile,
            "source": 'Hometown Leads',
            'referral': referral,
            "pro_id": (this.state.proid*1)
        }
    
        fetch(url,
        {
            method: 'post',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(json)                        
        })
        .then((response) => 
        {                               
            if(response.status === 400)
            {
                this.preloader('hide')
            }
        
            return response.json()
        })
        .then((response) => 
        {                            
            this.showOk()
            //this.redirect()                
        })
        .catch((error) => 
        {              
            console.log(error)
        })
    }

    showOk = () =>
    {
        this.forceclose = true        
        this.goto('ok')    
    }

    getKppUrl = (zip, redirect, goto = null) =>
    {
        const code = this.state.code === 'demolition' ? 'demolition-contractors' : this.state.code
        const endpoint = this.site === 'dumpster' ? '/api/v1/kpp/service_types/'+code+'/zip_codes/'+zip : '/api/v1/kpp/keywords/'+code+'/zip_codes/'+zip
        const url = this.service+endpoint            

        fetch(url,
        {
            method: 'get',                
        })
        .then((response) => 
        {                                       
            return response.json()
        })
        .then((response) => 
        {                             
            this.preloader('hide')
            this.preloadernext('hide')            

            if(Array.isArray(response))
            {                          
                //this.setState({'error': 'Zip not Found.'})
                this.setState({'redirect': '/redirect/no-zip-found'})
                return 
            }        

            this.cookies(zip)
                        
            this.setState({'redirect': response})

            if(redirect) this.redirect()
            
            if(goto !== null) this.goto(goto)
        })
        .catch((error) => 
        {              
            console.log(error)
        })
    }  

    cookies = (zip) =>
    {         
        Cookies.set('zipcode', zip)
    }

    redirect = () =>
    {                      
        window.location.replace('/'+this.state.redirect)
        //if(typeof this.state.redirect !== 'object' &&  !Array.isArray(this.state.redirect)) window.location.replace(this.state.redirect)                   
    }   

    moveStepsOut = (steps) =>
    {
        if($('#modalForm .steps.'+steps).length > 0){ $('#temp').append($('#modalForm .steps.'+steps)) }        
    }

    componentDidMount()
    {             
        $('.fire-modal').on('click', (e) =>
        {
            e.preventDefault()           
            
            const keygroup = $(e.target).data('keygroup')
            this.service_type = keygroup

            switch(keygroup)
            {
                case 'dumpster': case 'comercial-trash-service':
                    this.moveStepsOut('all')
                    $('#modalForm .steps.onlyzip').css('display','block')
                    this.setState({ onlyzip: true})
                    break
                
                default:
                    this.moveStepsOut('onlyzip')
                    this.setState({ onlyzip: false})
                    break
            }   
            
            if(keygroup !== undefined)
            {
                this.setState({ code: keygroup})
            }

            $('#quote-steps-modal').modal('show')
        })

        $('.fire-quote').on('click', (e) =>
        {
            e.preventDefault()           
            
            const proid = $(e.target).data('proid')

            this.setState({ proid: proid})

            $('#quote-steps-modal').modal('show')
        })
    }    

    render()
    {
        return(
           
            <div key="qsm-1" className="modal fade" id="quote-steps-modal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="quote-steps-modal-label" aria-hidden="true">
                <div key="qsm-2" className="modal-dialog" role="document">
                    <div key="qsm-3" className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close closermodal" onClick={ this.confirmClose } aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>

                            <div className="steps-progress">
                                <div className="bar">
                                    <div className="progress" id="steps-bar" style={{width: 0 + '%'}}></div>                                                                 
                                </div>
                                <div className="message"><span className="progress-message-percent">{this.state.percentage}</span> complete</div> 
                            </div>
                        </div>                        
                        <form id="modalForm" onSubmit={this.handleSubmit} key="qsm-4">     
                            {this.allSteps()}  
                            {this.onlyZipStep()}
                        </form>
                        <div id="temp"></div>      
                    </div>
                </div>
            </div>
        )
    }
}